import MapElement from "./MapElement";
import HeightmapDrawer from "../helpers/HeightmapDrawer"

export default class MapHeightmap extends MapElement {
    constructor(map, id, mapElementSettings, parent) {
        super(map, id, mapElementSettings, parent);


        this.dbVersion = 2;
        this.dark = false;
        this.settings = null;

        this.heightmap = { data: null, dataprojection: null, callback: null };

    }

    drawLayer(data, dataprojection, callback) {
        this.heightmap.data = data;
        this.heightmap.dataprojection = dataprojection;
        this.heightmap.callback = callback;
        this.draw().then(() => {
            if (!this.mapElementSettings.defaultOn) {
                this.hide();
            }
        });

    }

    async draw() {
        var layergroup = await HeightmapDrawer.drawHeightmap(this.heightmap.data, this.dark, this.heightmap.dataprojection, this.mapModel.projection, this.settings)
        if (layergroup == null) {
            console.log("could not draw heightmap");
            if (this.heightmap.callback)
                this.heightmap.callback(false);
        }
        console.log(layergroup);
        this.layer = layergroup;

        if (this.parent && this.parent.layer) {
            this.parent.layer.getLayers().push(this.layer);
        }

        if (this.heightmap.callback)
            this.heightmap.callback(true);
    }

    getExtent() {
        if (this.layer) return this.layer.getLayers().getArray()[0].getSource().getExtent();
        return null;
    }

    getData() {
        return this.heightmap.data;
    }

    setSettings(settings) {
        this.settings = settings;
        // same as clear() but without emptying the database

        if (this.parent.layer) {
            this.parent.layer.getLayers().forEach((value, index) => {
                //why value undefined?
                if (this.layer && value && value.ol_uid === this.layer.ol_uid) this.parent.layer.getLayers().removeAt(index);
            })
            this.layer = null;
            this.visible = true;
        }
    }

    clear() {
        if (this.heightmap.data != null) HeightmapDrawer.clear();
        super.clear();
    }
}